<template @scroll.native="handleScroll">
  <div id="top" class="xxhd_document" style="position: relative">
    <div
      v-preventReClick
      style="
        position: absolute;
        right: 30px;
        top: 30px;
        font-size: 30px;
        color: #606266;
        cursor: pointer;
      "
      @click="back"
    >
      <i class="el-icon-circle-close" />
    </div>
    <div class="document_content">
      <div class="_content_top">
        <div class="title">
          {{ title }}
        </div>
        <div
          style="display: flex; justify-content: center; margin-bottom: 25px"
        >
          <div style="margin-right: 30px">
            <span style="float: left">发布时间：</span>{{ fbsj }}
          </div>
          <div style="">
            <span style="float: left">发布机关：</span>{{ fbjg }}
          </div>
        </div>
      </div>
      <div class="_content_text" v-html="content">
        <!-- <p>一、项目名称:药品类易制毒化学品的生产审批</p>
        <p>二、许可内容:药品类易制毒化学品生产的审批</p>
        <p>三、设定许可的法律依据:《易制毒化学品管理条例》第八条</p>
        <p>四、收费:不收费</p>
        <p>五、数量限制:本许可事项无数量限制</p>
        <p>六、申请材料目录:</p>
        <ul>
          <li>(一)药品类易制毒化学品生产申请表。</li>
          <li>(二)《药品生产许可证》和《单位法人/经营者营业执照》复印件。</li>
          <li>
            (三)单位药品类易制毒化学品管理的组织机构图（注明各部门职责及相互关系、部门负责人).
          </li>
          <li>
            (四)单位周边环境图、总平面布置图、仓储平面布置图、质量检验场所平面布置图（注明药品类易制毒化学品所在相应位置)。
          </li>
          <li>
            (五）药品类易制毒化学品生产工艺布局平面图，工艺设备平面布置图（注明相应安全管理设施)。
          </li>
          <li>
            (六）单位没有生产、销售假药、劣药的行为的说明材料;单位及其工作人员无违反有关禁毒的法律、行政法规规定行为的说明材料。
          </li>
          <li>(七)药品类易制毒化学品安全管理制度文件目录。</li>
        </ul>

        <p>七、对申请资料的要求:</p>
        <p>申报资料的一般要求:</p>
        <ul>
          <li>
            1、申请项目及内容准确，申请材料完整、清晰，使用A4规格纸单面打印或复印。中文不得小于宋体小4号字，英文不得小于12号字，内容应完整、清楚，不得涂改。
          </li>
          <li>2、申请人提交的资质证书必须有效。</li>
          <li>3、申报资料所附图片必须清晰易辨。</li>
        </ul> -->
      </div>
      <div
        v-if="fjUrl"
        v-preventReClick
        style="
          text-align: right;
          font-size: 15px;
          color: blue;
          cursor: pointer;
          padding-bottom: 30px;
        "
        @click="downloadCompile"
      >
        下载附件
      </div>
    </div>
    <div v-show="gotop" class="returnTop" @click="toTop">Top</div>
  </div>
</template>
<script>
import { downloadPic } from '@/assets/js/common.js'
export default {
  // props: {
  //   title: String,
  //   fbsj: String,
  //   fbjg: String,
  //   content: String,
  //   fjUrl: String,
  //   clckiName
  // },
  components: {},
  props: ['title', 'fbsj', 'fbjg', 'content', 'fjUrl', 'clckiName'],
  data() {
    return {
      // fbsj: "2021-04-01",
      // fbjg: "xxx行政区划",
      result: 'png',
      gotop: false
    }
  },
  computed: {},
  watch: {},
  mounted() {
    window.addEventListener('scroll', this.handleScroll, true)
    if (this.fjUrl !== null) {
      const index = this.fjUrl.lastIndexOf('/')
      this.result = this.fjUrl.substr(index + 1, this.fjUrl.length)
    }
  },
  beforeDestroy() {},
  methods: {
    handleScroll(event) {
      const scrolltop = event.target.scrollTop
      scrolltop > 30 ? (this.gotop = true) : (this.gotop = false)
    },
    toTop() {
      document
        .querySelector('#top')
        .scrollIntoView({ block: 'start', behavior: 'smooth' })
    },
    // 下载附件
    downloadCompile() {
      downloadPic(this.fjUrl).then((res) => {
        const fileSuffix = this.fjUrl.substring(this.fjUrl.lastIndexOf('.') + 1)
        let fileTypeMime = '' // 文件 mime 类型，移动端必传，否则下载不成功；pc端可传可不传
        switch (fileSuffix) { // 获取后缀对应的 mime
          case 'png': fileTypeMime = 'image/png'; break
          case 'doc': fileTypeMime = 'application/msword'; break
          case 'docx': fileTypeMime = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'; break
          case 'jpg': case 'jpeg': fileTypeMime = 'image/jpeg'; break
          case 'gif': fileTypeMime = 'image/gif'; break
          case 'svg': fileTypeMime = 'image/svg+xml'; break
          case 'tif': case 'tiff': fileTypeMime = 'image/tiff'; break
          case 'txt': fileTypeMime = 'text/plain'; break
          case 'ppt': fileTypeMime = 'application/vnd.ms-powerpoint'; break
          case 'pptx': fileTypeMime = 'application/vnd.openxmlformats-officedocument.presentationml.presentation'; break
          case 'xls': fileTypeMime = 'application/vnd.ms-excel'; break
          case 'xlsx': fileTypeMime = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'; break
          case 'zip': fileTypeMime = 'application/zip'; break
          case '7z': fileTypeMime = 'application/x-7z-compressed'; break
        }
        const blob = new Blob([res.data], {
          type: fileTypeMime
        })
        const downloadElement = document.createElement('a')
        const href = window.URL.createObjectURL(blob)
        downloadElement.href = href
        // downloadElement.download = "通知文件" + ".png";
        downloadElement.download = this.result
        document.body.appendChild(downloadElement)
        downloadElement.click()
        // 触发下载之后清掉
        setTimeout(() => {
          window.URL.revokeObjectURL(href)
          document.body.removeChild(downloadElement)
        })
      })
    },
    back() {
      if (this.clckiName == '首页') {
        this.$parent.navtab1 = true
        this.$parent.XxhdDocumentShow = false
      } else {
        this.$parent.pupopShow = false
      }
    }
  }
}
</script>
<style scoped lang="less">
.returnTop {
  /*
  position: absolute; */
  color: aqua;
  text-align: center;
  position: fixed;
  right: 50px;
  bottom: 30px;
  cursor: pointer;
  padding: 10px;
  border-radius: 50%;
  background: white;
  color: #000000;
}
.xxhd_document {
  width: 90%;
  max-width: 1100px;
  background-color: white;
  margin: auto;
  margin-top: 30px;
  margin-bottom: 30px;
  .document_content {
    width: 80%;
    margin: auto;
    ._content_top {
      background-color: white;
      padding-top: 40px;
      text-align: center;
      border-bottom: 2px solid #de948f;
      .title {
        font-size: 26px;
        margin-bottom: 25px;
      }
    }
    ._content_text {
      padding: 30px 60px;
      ul {
        list-style: none;
        li {
          margin: 30px;
        }
      }
    }
  }
}
</style>
<style>
._content_text img {
  display: block;
  width: 80%;
  margin-left: auto;
  margin-right: auto;
}
</style>
